/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { selectComposerFieldState } from "data/store/reducers/composer";

const useFieldOpen = () => {
    const fields = useSelector(selectComposerFieldState);
    
    const getNamedField = (name) => {
        const field = fields?.find((field) => {
            return field.name === name;
        });
        return field;
    };
    
    const getNamedFieldIsOpen = (name) => {
        const field = fields?.find((field) => {
            return field.name === name;
        });
        return field ? field?.open || false : false;
    };
    
    return { getNamedField, getNamedFieldIsOpen };
};

export { useFieldOpen };
